import { Check } from "lucide-react";

function circleClass(done, active) {
  if (done) return "bg-[#002FA7] border-[#002FA7] text-white";
  if (active) return "border-[#002FA7] text-[#002FA7] bg-white";
  return "border-zinc-300 text-zinc-400 bg-white";
}

function labelClass(done, active) {
  if (active) return "text-zinc-900";
  if (done) return "text-zinc-600";
  return "text-zinc-400";
}

export default function Stepper({ steps, current }) {
  return (
    <div className="w-full overflow-x-auto" data-testid="workflow-stepper">
      <ol className="flex items-center min-w-max gap-0">
        {steps.map((label, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <li key={label} className="flex items-center">
              <div className="flex items-center gap-2.5">
                <span
                  className={[
                    "flex h-8 w-8 items-center justify-center rounded-full border text-sm font-semibold transition-colors",
                    circleClass(done, active),
                  ].join(" ")}
                >
                  {done ? <Check className="h-4 w-4" /> : i + 1}
                </span>
                <span
                  className={["text-xs sm:text-sm whitespace-nowrap font-medium", labelClass(done, active)].join(" ")}
                >
                  {label}
                </span>
              </div>
              {i < steps.length - 1 && (
                <span className={["mx-3 h-px w-8 sm:w-12", done ? "bg-[#002FA7]" : "bg-zinc-200"].join(" ")} />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
